import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import Tooltip from 'components/Tooltip/Tooltip';

const messages = defineMessages({
  muteAll: { id: 'notification.muteAll', defaultMessage: 'The moderator has muted your microphone. You cannot unmute.' },
});

const MuteTooltip = ({ notification, isMinimized, intl }) => {
  const hasNotification =
      (notification === intl.formatMessage(messages.muteAll));
  if (hasNotification) return null;

  if (isMinimized) {
    return (
      <Tooltip
        location="right"
        fixPosition
        style={{ bottom: '100%', marginLeft: 15 }}
        label={intl.formatMessage(messages.muteAll)}
      />);
  }

  return (
    <Tooltip
      location="top"
      fixPosition
      offset={{ top: -15 }}
      style={{ bottom: '100%', marginBottom: 15 }}
      label={intl.formatMessage(messages.muteAll)}
    />);
};

MuteTooltip.propTypes = {
  notification: PT.string,
  isMinimized: PT.bool,
  intl: PT.object
};

export default injectIntl(MuteTooltip);
